/**
 * Layout Menu Component
 * 
 * Context menu for pre-configured city layouts with nested categories
 * Similar to TemplateMenu but with category-based organization
 */

// Import layout data
import { LAYOUT_DATA } from './LayoutData.js';

export class LayoutMenu {
    constructor() {
        this.element = null;
        this.isOpen = false;
        this.onLoadLayout = null;
        this.layouts = { ...LAYOUT_DATA };
        
        // Add Overlays category with template overlays
        this.layouts['Overlays'] = [
            {
                layoutName: 'Barracks',
                layoutString: 'W00000000000000000000000000000000000000000000000000000000000000000000000000000000000P0P0P000000000PPPPPPP00000000P0000000P00000000PPPPPPPPP0000P0000000P0000PPPPPPPPP00000000P0000000P00000000PPPPPPP000000000P0P0P00000000000000000000000000000000000000000000000000000000000000000000000000000000000',
                layoutRemark: '',
                layoutNote: '',
                layoutTroops: null,
                layoutResources: null
            },
            {
                layoutName: 'Barracks + Training Gnd',
                layoutString: 'W00000000000000000000000000000000000000000000000000000000000000000000000000000000000PQPQP000000000PPPPPPP00000000PQQQQQQQP00000000PPPPPPPPP0000PQQQ0QQQP0000PPPPPPPPP00000000PQQQQQQQP00000000PPPPPPP000000000PQPQP00000000000000000000000000000000000000000000000000000000000000000000000000000000000',
                layoutRemark: '',
                layoutNote: '',
                layoutTroops: null,
                layoutResources: null
            },
            {
                layoutName: 'Barracks + Temple',
                layoutString: 'W00000000000000000000000000000000000000000000000000000000000000000000000000000000000PWPWP000000000PPPPPPP00000000PWWWWWWWP00000000PPPPPPPPP0000PWWW0WWWP0000PPPPPPPPP00000000PWWWWWWWP00000000PPPPPPP000000000PWPWP00000000000000000000000000000000000000000000000000000000000000000000000000000000000',
                layoutRemark: '',
                layoutNote: '',
                layoutTroops: null,
                layoutResources: null
            },
            {
                layoutName: 'Barracks + Stable',
                layoutString: 'W00000000000000000000000000000000000000000000000000000000000000000000000000000000000PUPUP000000000PPPPPPP00000000PUUUUUUUP00000000PPPPPPPPP0000PUUU0UUUP0000PPPPPPPPP00000000PUUUUUUUP00000000PPPPPPP000000000PUPUP00000000000000000000000000000000000000000000000000000000000000000000000000000000000',
                layoutRemark: '',
                layoutNote: '',
                layoutTroops: null,
                layoutResources: null
            },
            {
                layoutName: 'Barracks + Sorcerer\'s Tower',
                layoutString: 'W00000000000000000000000000000000000000000000000000000000000000000000000000000000000PRPRP000000000PPPPPPP00000000PRRRRRRRP00000000PPPPPPPPP0000PRRR0RRRP0000PPPPPPPPP00000000PRRRRRRRP00000000PPPPPPP000000000PRPRP00000000000000000000000000000000000000000000000000000000000000000000000000000000000',
                layoutRemark: '',
                layoutNote: '',
                layoutTroops: null,
                layoutResources: null
            },
            {
                layoutName: 'Barracks + Blacksmith',
                layoutString: 'W00000000000000000000000000000000000000000000000000000000000000000000000000000000000PVPVP000000000PPPPPPP00000000PVVVVVVVP00000000PPPPPPPPP0000PVVV0VVVP0000PPPPPPPPP00000000PVVVVVVVP00000000PPPPPPP000000000PVPVP00000000000000000000000000000000000000000000000000000000000000000000000000000000000',
                layoutRemark: '',
                layoutNote: '',
                layoutTroops: null,
                layoutResources: null
            },
            {
                layoutName: 'Navy',
                layoutString: 'W000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000PPPP0000000PPYYPP000000000000PY00YP000000000000PY000Y00000000000PPY0000000000000PPY',
                layoutRemark: '',
                layoutNote: '',
                layoutTroops: null,
                layoutResources: null
            },
            {
                layoutName: 'Gold City',
                layoutString: 'W0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000EEEEEEEEEE00000EJEJEJEJEEJE00000EEEEEEEEEEEE0EJEJ0JEJE0000EEEEEEEEE00000000EJEJEJEJEEEE00000EEEEEEEEJE00000000000EEEE0000000EETTEE0000000000EEET00TE0000000000EJET0000000000000EEEET0000000000000EE0',
                layoutRemark: '',
                layoutNote: '',
                layoutTroops: null,
                layoutResources: null
            },
            {
                layoutName: 'Temple Warehouse',
                layoutString: 'L0000000JJJJJJJ00000000JJJJJJJJ000000000JJJJJJJJJ000000000JJJJJJJJJ000000JJJJJJ00000ZZZZZJJJJJ00000KKKKK0JJJJ000000ZZZZZ00JJJJ000000KKKKK00JJJ000ZZ0ZZ00000000LLLLL000000000000ZZZZZ00000000000LLLLL0000000000ZZZZZ0000000000000000000000000R000000000000000000000000000000000000000000000000000000000',
                layoutRemark: '',
                layoutNote: '',
                layoutTroops: null,
                layoutResources: null
            }
        ];
        
        this.createMenu();
    }
    
    /**
     * Create the menu element with nested categories
     */
    createMenu() {
        const menu = document.createElement('div');
        menu.id = 'layout-menu';
        menu.className = 'layout-menu';
        
        // Build category structure
        const categoryItems = Object.keys(this.layouts).map((categoryName, categoryIndex) => {
            const layouts = this.layouts[categoryName];
            const layoutItems = layouts.map((layout, layoutIndex) => {
                const uniqueId = `layout-${categoryIndex}-${layoutIndex}`;
                return `
                    <button 
                        id="${uniqueId}" 
                        class="layout-menu-item" 
                        data-category="${categoryIndex}"
                        data-layout="${layoutIndex}"
                        title="${layout.layoutNote || ''}">
                        ${layout.layoutName}
                    </button>
                `;
            }).join('');
            
            return `
                <div class="layout-menu-category">
                    <div class="layout-menu-category-header" id="layout-category-${categoryIndex}">
                        ${categoryName} ▶
                    </div>
                    <div class="layout-menu-submenu" id="layout-submenu-${categoryIndex}" style="display: none;">
                        ${layoutItems}
                    </div>
                </div>
            `;
        }).join('');
        
        menu.innerHTML = `
            <div class="layout-menu-content">
                ${categoryItems}
            </div>
        `;
        
        document.body.appendChild(menu);
        this.element = menu;
        
        // Setup event listeners for category headers
        Object.keys(this.layouts).forEach((categoryName, categoryIndex) => {
            const header = document.getElementById(`layout-category-${categoryIndex}`);
            const submenu = document.getElementById(`layout-submenu-${categoryIndex}`);
            
            if (header && submenu) {
                header.addEventListener('click', (e) => {
                    e.stopPropagation();
                    const isVisible = submenu.style.display !== 'none';
                    submenu.style.display = isVisible ? 'none' : 'block';
                    header.textContent = isVisible ? `${categoryName} ▶` : `${categoryName} ▼`;
                });
            }
        });
        
        // Setup event listeners for layout items
        Object.keys(this.layouts).forEach((categoryName, categoryIndex) => {
            const layouts = this.layouts[categoryName];
            layouts.forEach((layout, layoutIndex) => {
                const btn = document.getElementById(`layout-${categoryIndex}-${layoutIndex}`);
                if (btn) {
                    btn.addEventListener('click', (e) => {
                        e.stopPropagation();
                        if (this.onLoadLayout) {
                            // Pass the full layout object so we can access layoutTroops
                            this.onLoadLayout(layout);
                        }
                        this.hide();
                    });
                }
            });
        });
        
        // Close on outside click
        document.addEventListener('click', (e) => {
            if (this.isOpen && !this.element.contains(e.target)) {
                const btn = document.getElementById('btn-layouts');
                if (btn && !btn.contains(e.target)) {
                    this.hide();
                }
            }
        });
        
        this.hide();
    }
    
    /**
     * Show menu at position
     */
    show(x, y) {
        this.element.style.display = 'block';
        this.element.style.left = `${x}px`;
        this.element.style.top = `${y}px`;
        this.isOpen = true;
    }
    
    /**
     * Hide menu
     */
    hide() {
        this.element.style.display = 'none';
        this.isOpen = false;
        
        // Close all submenus
        Object.keys(this.layouts).forEach((categoryName, categoryIndex) => {
            const header = document.getElementById(`layout-category-${categoryIndex}`);
            const submenu = document.getElementById(`layout-submenu-${categoryIndex}`);
            if (header && submenu) {
                submenu.style.display = 'none';
                header.textContent = `${categoryName} ▶`;
            }
        });
    }
    
    /**
     * Toggle menu visibility
     */
    toggle(x, y) {
        if (this.isOpen) {
            this.hide();
        } else {
            this.show(x, y);
        }
    }
}
